import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { Status } from "api/schemas/CareEventBilling";
import { BaseButton } from "shared/atoms/BaseButton";
import { MUIUnifiedModal } from "shared/atoms/MUIUnifiedModal";
import { Notification } from "shared/atoms/Notification";

interface Props {
  open: boolean;
  status: Status;
  count: number;
  isLoading: boolean;
  error: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export function StatusUpdateDialog({ open, status, count, isLoading, error, onConfirm, onCancel }: Props) {
  const { t } = useTranslation();

  return (
    <MUIUnifiedModal
      open={open}
      onClose={onCancel}
      width="450px"
      title={
        status === "completed"
          ? t("admin_billing.mark_as_completed", { count })
          : t("admin_billing.mark_as_discarded", { count })
      }
    >
      <Stack alignItems="center" p={2} pb={3} spacing={1}>
        <BaseButton
          text={t("buttons.yes")}
          onClick={onConfirm}
          disabled={isLoading}
          loading={isLoading}
          uppercase
          style={{ marginBottom: "20px" }}
        />
        <BaseButton
          text={t("buttons.cancel")}
          onClick={onCancel}
          disabled={isLoading}
          variant="tertiaryBlue"
          uppercase
        />
        {error && (
          <Notification variant="danger" style={{ marginTop: "16px" }}>
            {error}
          </Notification>
        )}
      </Stack>
    </MUIUnifiedModal>
  );
}
